"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPrompt = void 0;
const api_1 = require("../api");
const constant_1 = require("../constant");
const buildPrompt = (docType, text, options) => {
    var _a;
    const { selectedHtml, generatedCode, } = options;
    let updatedText = text.trim();
    if (docType !== api_1.DOC_TYPE.FORM) {
        const promptMap = {
            [api_1.DOC_TYPE.WORD]: () => {
                updatedText = (0, constant_1.AI_PROMPT_WORD)(updatedText);
            },
            [api_1.DOC_TYPE.PPT]: () => {
                updatedText += `${constant_1.AI_PROMPT_PPT}\nUser request: ${updatedText}`;
            },
            [api_1.DOC_TYPE.PDF]: () => {
                updatedText += `${constant_1.AI_PROMPT_PDF}\nUser request: ${updatedText}`;
            },
        };
        (_a = promptMap[docType]) === null || _a === void 0 ? void 0 : _a.call(promptMap);
        if (selectedHtml) {
            updatedText += `\n\nSelected HTML:\n${selectedHtml}`;
            updatedText += `\n\nOriginal HTML:\n${generatedCode}`;
            updatedText += `\n\n${constant_1.SELECTED_AI_PROMPT.trim()}`;
        }
    }
    else {
        if (selectedHtml) {
            updatedText += `\n\nSelected HTML:\n${selectedHtml}`;
            updatedText += `\n\nOriginal HTML:\n${generatedCode}`;
            updatedText += `\n\n${constant_1.SELECTED_AI_PROMPT.trim()}`;
        }
        else {
            updatedText += `\n\n${constant_1.AI_PROMPT.trim()}`;
        }
    }
    return updatedText;
};
exports.buildPrompt = buildPrompt;
